<template>
  <div>
    <v-container class="pa-4 responsive-container">
      <v-card class="mx-auto" max-width="420">
        <v-card-title class="d-flex justify-space-between align-center">
          <v-btn v-if="isnew" class="new-btn" depressed color="red darken-1" dark>NEW</v-btn>
          <div class="d-flex align-center">
            <div class="speed display-1 font-weight-bold">{{ mbps }}</div>
            <h4 class="mbps-label">{{ mbpslbl }}</h4>
            <div class="subtitle-1 font-weight-bold mx-1"> + </div>
            <div class="square-avatar">
              <img src="https://unifi.com.my/tv/sites/default/files/2023-05/Netflix-App-Logo.png" alt="Netflix" />
            </div>
          </div>
        </v-card-title>
        <v-card-subtitle class="text-h4 font-weight-bold">
          RM{{price}}/month
        </v-card-subtitle>
        <v-card-subtitle class="subtitle-2 grey--text">
            RM204/mth after 24 months contract
          </v-card-subtitle>
        <v-card-actions>
          <v-btn
            class="upgrade-btn"
            large
            color="black"
            dark
            @mouseover="hoverButton = true"
            @mouseleave="hoverButton = false"
            @click="upgradePlan('Unifi Home Package')"
            :style="{ backgroundColor: hoverButton ? '#FF7400' : '#FF2A00' }"
          >
            UPGRADE TO THIS PLAN
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text>
          <v-subheader>What's included:</v-subheader>
          <v-list dense class="overflow-hidden">
            <template v-for="(feature, index) in features" :key="index">
              <div @click="toggleFeature(index)" class="d-flex justify-space-between align-center">
                <div class="d-flex align-center flex-grow-1">
                  <div class="font-size-lg">{{ feature.title }}</div>
                </div>
                <v-icon>{{ feature.expanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
              </div>
              <v-expand-transition>
                <div v-if="feature.expanded">
                  <ul>
                    <li v-for="detail in feature.details" :key="detail" v-html="detail" class="font-size-lg"></li>
                  </ul>
                </div>
              </v-expand-transition>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "unifiChild3",
  props: {
    mbps: {
      type: Number,
      required: true,
    },
    mbpslbl: {
      type: String,
      required: true,
    },
    isnew: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      price:198,
      hoverButton: false,
      features: [
        {
          title: "UNIFI HOME",
          expanded: false,
          details: [
            "2Gbps(DL)/1Gbps(UL)",
            "Wi-Fi 6 Combo Box",
            "12 Business Hours Service Restoration",
            "FREE 600 minutes to fixed & mobile",
            "Beyond call rates:  *FREE to TM Fixed Line",
            "*10 sen/minute to other Fixed Lines",
            "*10 sen/minute to Mobile",
          ],
        },
        // {
        //   title: "UNIFI WIFI",
        //   expanded: false,
        //   details: [
        //     "-",
        //   ],
        // },
        // {
        //   title: "UNIFI PHONE",
        //   expanded: false,
        //   details: [
        //     "60GB Unlimited 5G+4G Data",
        //     "Unlimited Calls",
        //     "60GB Hotspot from data quota",
        //     "15 sen per SMS",
        //   ],
        // },
        {
          title: "NETFLIX STANDARD",
          expanded: false,
          details: [
            "✔Unlimited ad-free movies, TV shows, and mobile games",
            "✔Watch on 2 supported devices at a time",
            "✔Watch in Full HD",
            "✔Download on 2 supported devices at a time",
          ],
        },
      ],
    };
  },
  methods: {
    toggleFeature(index) {
      this.features[index].expanded = !this.features[index].expanded;
    },
    upgradePlan() {
      const packageName = `Unifi Package ${this.mbps} ${this.mbpslbl} - RM${this.price}`;
      this.$emit('upgrade', packageName);
    },
  },
};
</script>

<style scoped>
.responsive-container {
  max-width: 420px;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .responsive-container {
    padding: 0 16px;
  }

  .speed {
    font-size: 28px !important;
  }

  .mbps-label {
    font-size: 12px !important;
    margin-left: 4px;
    margin-right: 4px;
  }

  .subtitle-1 {
    font-size: 12px !important;
  }

  .text-h4 {
    font-size: 16px !important;
  }

  .new-btn {
    font-size: 12px !important;
  }

  .upgrade-btn {
    font-size: 12px !important;
  }

  .square-avatar {
    width: 40px !important;
    height: 40px !important;
  }

  .font-size-lg {
    font-size: 14px !important;
  }
}

.new-btn {
  background-image: linear-gradient(to right, #707070, #FF0000);
  background-size: 100% 200px;
  background-position: 0% 100%;
  transition: background-position 0.3s ease-out;
}

.new-btn:hover {
  background-position: 100% 100%;
}

.speed {
  font-size: 48px;
  font-weight: bold;
}

.mbps-label {
  margin-left: 8px;
  margin-right: 8px;
}

.upgrade-btn {
  transition: background-color 0.3s;
}

.square-avatar {
  width: 60px;
  height: 60px;
  display: inline-block;
  overflow: hidden;
  position: relative;
  background-color: #f5f5f5;
}

.square-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.font-size-lg {
  font-size: 18px;
}

.v-list {
  cursor: pointer;
}

.v-expand-transition {
  overflow: hidden;
}

/* Ensure flexbox utility classes are defined */
.d-flex {
  display: flex;
}

.justify-space-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.ml-auto {
  margin-left: auto;
}
</style>
